import * as React from 'react';
import { AdminDashboardPageLayout } from '../../containers/AdminDashboardPageLayout';
import { AccountCustomerAssistant } from '../../containers/AccountCustomerAssistant';
import { Portal } from '@WebComponents/Portal';
import { MastheadPortalId } from '@AppModels/AdminModels';
import { AccountDetailsBreadcrumb } from '../../containers/account/AccountDetails/AccountDetailsBreadcrumb';
import { BreadcrumbItem, BreadcrumbPage, BreadcrumbSeparator } from '@WebComponents/Breadcrumb';
import { useParams } from 'react-router';
import { AdminDrawerToolbar, AppDrawerToolbarButton, SideDrawer, StickyAppDrawerContent } from '@HoudiniUI/Drawer';
import { AdminAppAssistantChat, SurveyBuilderAppAssistantChat } from '../../../web/containers/templates/AssistantChat';
import { IImpersonationContext } from '@ViewModels';
import { ConditionalAccess } from '../../components/ConditionalAccess';
import { AdminPermission } from '../../../viewmodels/AdminViewModels';
import { useAccountDetailsData } from '../AdminAccountDetailsPage/useAccountDetailsData';
import { SparklesIcon } from '@WebComponents/svgs/icons/SparklesIcon';
import { ClipboardIcon2 } from '@WebComponents/svgs/icons/ClipboardIcon';

export const AdminAccountCustomerAssistantPage: React.FC = () => {
	const { accountId } = useParams<{ accountId: string }>();
	const { account } = useAccountDetailsData(accountId);
	const impersonationContext: IImpersonationContext = { account: { id: accountId } };
	return (
		<AdminDashboardPageLayout
			sidebarChildren={
				<SideDrawer>
					<StickyAppDrawerContent value='ai-assistant'>
						<AdminAppAssistantChat impersonationContext={impersonationContext} />
					</StickyAppDrawerContent>
					<ConditionalAccess permission={AdminPermission.ModifyAccount}>
						{account.features?.surveys?.enabled ? (
							<StickyAppDrawerContent value='survey-builder'>
								<SurveyBuilderAppAssistantChat impersonationContext={impersonationContext} />
							</StickyAppDrawerContent>
						) : null}
					</ConditionalAccess>
					<AdminDrawerToolbar>
						<AppDrawerToolbarButton value='ai-assistant' tooltip='AI Assistant'>
							<SparklesIcon />
						</AppDrawerToolbarButton>
						<ConditionalAccess permission={AdminPermission.ModifyAccount}>
							{account.features?.surveys?.enabled ? (
								<AppDrawerToolbarButton value='survey-builder' tooltip='Survey Assistant'>
									<ClipboardIcon2 />
								</AppDrawerToolbarButton>
							) : null}
						</ConditionalAccess>
					</AdminDrawerToolbar>
				</SideDrawer>
			}
		>
			<Portal destination={MastheadPortalId}>
				<AccountDetailsBreadcrumb accountId={accountId!} getAccountPageUrl={id => `/accounts/${id}/customer-assistant`}>
					<BreadcrumbSeparator />
					<BreadcrumbItem>
						<BreadcrumbPage>Customer Assistant</BreadcrumbPage>
					</BreadcrumbItem>
				</AccountDetailsBreadcrumb>
			</Portal>
			<AccountCustomerAssistant />
		</AdminDashboardPageLayout>
	);
};
